"use client"
import React, { useContext } from "react"
import styles from "./About.module.scss"
import Container from "../Container/Container"
import Row from "../Row/Row"
import Col from "../Col/Col"
import Spacer from "../Spacer/Spacer"
import RegularButton from "../RegularButton/RegularButton"
import { ModalContext } from "@/contexts/ModalProvider"

export default function About({
  title,
  desc,
  date,
  programme_title,
  programme,
  signupText = "Register now",
}) {
  const { setOpenModal } = useContext(ModalContext)

  return (
    <section className={styles.about} id="about">
      <Container>
        <Row>
          <Col cols="12" sm="24" lg="11">
            <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
            <div
              className={styles.about__desc}
              dangerouslySetInnerHTML={{ __html: desc }}
            ></div>
          </Col>
          <Spacer></Spacer>
          <Col cols="12" sm="24" lg="11">
            <div
              className={styles.about__date}
              dangerouslySetInnerHTML={{ __html: date }}
            ></div>
            <div className={styles.about__timetable}>
              {programme_title && (
                <div
                  className={styles.about__timetableTitle}
                  dangerouslySetInnerHTML={{ __html: programme_title }}
                ></div>
              )}
              <div dangerouslySetInnerHTML={{ __html: programme }}></div>
            </div>
            <RegularButton
              text={signupText}
              onClick={() => setOpenModal(true)}
            ></RegularButton>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
